export default __webpack_public_path__ + "static/media/Work Visa - Overview.07f69e77.jpg";